// extracted by mini-css-extract-plugin
export default {"mostSearchedTitle":"mostSearchedTitle__0IEiv"};